<div class="mb-6 flex flex-col gap-6">
  <app-metric-selector
    [data]="globalData()!"
    [previousPeriodData]="previousPeriodGlobalData()"
    (selectedMetricsChange)="selectMetrics($event)"
    [availableMetrics]="CHART_METRICS"
    [localStorageKey]="localStorageKey"
  />
  <app-chart-layout
    [withDateAggregation]="!!dateAggregation()"
    [withEventAnnotation]="true"
    [allEventAnnotationTypes]="allEventAnnotationTypes"
    [disableEventAnnotation]="disableEventAnnotation()"
    (aggregationChange)="selectAggregation($event)"
    (displayEventAnnotationChange)="toggleEventAnnotation($event)"
  >
    <IChart [config]="chartConfig()" [data]="strategyDailyStats()" />
  </app-chart-layout>
</div>
